import script from "./MenuCategory.vue?vue&type=script&setup=true&lang=js"
export * from "./MenuCategory.vue?vue&type=script&setup=true&lang=js"

import "./MenuCategory.vue?vue&type=style&index=0&id=28a798b2&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-28a798b2"]])

export default __exports__